import types from "@/data/types"

/**
 * Platform-specific header ignore values
 * These headers will always be hidden by default but can be shown via DataTable column visibility
 */
const headerIgnore = (type) => {
    switch (type) {
        case types.PACIOLAN_SCRAPE:
            return [
                'id',
                'timestamp',
                '_item',
                '_search',
                'event_date',
                'event_season_name',
                'ticket_id_eres',
                'ticket_id_transfer',
                'ticket_id_seat',
                'ticket_level',
                'ticket_is_transferable',
                'ticket_transfer_status',
                'ticket_transfer_id',
                'ticket_is_sellable',
                'ticket_is_nfc_enabled',
                'ticket_id_mta',
                'account_team',
                'account_user'
            ]
        case types.SEATGEEK_SCRAPE:
            return [
                'id',
                'timestamp',
                '_item',
                '_search',
                'account_user',
                'event_id',
                'event_time'
            ]
        default:
            return [
                'id',
                'timestamp',
                '_item',
                '_search'
            ]
    }
}

export default headerIgnore

